import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { buildPlanApiConfig } from './plan.api';
import { LOAD_STATE } from '../../../shared/axios';

export const GET_PLANS = '@pricing/plan/GET_PLANS';
export const GET_PRICING_PLANS_REQUEST_CALLED = '@pricing/plan/GET_PRICING_PLANS_REQUEST_CALLED';
export const GET_PRICING_PLANS_REQUEST_SUCCEEDED = '@pricing/plan/GET_PRICING_PLANS_REQUEST_SUCCEEDED';
export const GET_PRICING_PLANS_REQUEST_FAILED = '@pricing/plan/GET_PRICING_PLANS_REQUEST_FAILED';

export const getPlansData = state => state.pricing.plan.data;
export const getPlansLoadState = state => state.pricing.plan.loadState;
export const getPlan = (state, planId) => getPlansData(state)
    .find(plan => plan.id === planId);

export const getPlansRequest = () => ({
    type: GET_PRICING_PLANS_REQUEST_CALLED,
    actionTypes: {
        success: GET_PRICING_PLANS_REQUEST_SUCCEEDED,
        fail: GET_PRICING_PLANS_REQUEST_FAILED,
    },
    config: buildPlanApiConfig(),
});

export const getPlans = () => ({
    type: GET_PLANS,
    payload: {},
});

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: [],
    error: null,
};

export const plansReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_PRICING_PLANS_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    }),
    [GET_PRICING_PLANS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: action.payload.data,
        error: null,
    }),
    [GET_PRICING_PLANS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: action.payload.data,
    }),
});
